/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _getFocusableElements.default;
  }
});
var _getFocusableElements = _interopRequireDefault(require("../packages/getFocusableElements"));


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/getFocusableElements.js
// module id = 580
// module chunks = 0